import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SignalState {
  active: {
    [key: string]: boolean;
  };
}

const defaultState: SignalState = {
  active: {},
};

const signalSlice = createSlice({
  name: "signal",
  initialState: defaultState,
  reducers: {
    trigger: (state, action: PayloadAction<string>) => {
      state.active[action.payload] = true;
    },
    clear: (state, action: PayloadAction<string>) => {
      state.active[action.payload] = false;
    },
  },
});

export const { trigger, clear } = signalSlice.actions;
export const signalReducer = signalSlice.reducer;
